export default __webpack_public_path__ + "static/media/message.06fe4934.svg";